import { render, staticRenderFns } from "./ask-a-trade.vue?vue&type=template&id=0e7ac0e1&scoped=true"
import script from "./ask-a-trade.vue?vue&type=script&lang=js"
export * from "./ask-a-trade.vue?vue&type=script&lang=js"
import style0 from "./ask-a-trade.vue?vue&type=style&index=0&id=0e7ac0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ac0e1",
  null
  
)

export default component.exports